import { getPartnerSignupConnectorById } from '@avalara/bat-apps-shared/constants';
import { checkIsAuthenticated } from '../lib/helpers';

import type { State } from '@avalara/types/reducer-states';

export const selectShouldRedirectAfterPurchase = (state: State) => {
  const {
    account: {
      connector: { id: connectorId },
    },
    order: { isConnectorValidated },
  } = state;

  const partnerSignupConnector = getPartnerSignupConnectorById(connectorId);

  // NOTE (Andrew) - we need to default to true here in the case that we don't maintain the
  //                 connector in question in our partner signup map:
  const shouldShowLicenseKey = partnerSignupConnector?.shouldShowLicenseKey ?? true;

  const showLicensePage = isConnectorValidated && shouldShowLicenseKey && !checkIsAuthenticated();
  return !showLicensePage;
};
